import { v4 as uuidv4 } from 'uuid';

const clearWebStorage = (prefix)=> {
  for(let i = 0; i < localStorage.length; i++){
    if(localStorage.key(i).startsWith(prefix))
      localStorage.removeItem(localStorage.key(i));
  }
};

const getFromWebStorage = (prefix)=> {
  let key = null;

  for(let i = 0; i < localStorage.length; i++){
    if(localStorage.key(i).startsWith(prefix))
      key = localStorage.key(i);
  }
  
  return (key != null) ? JSON.parse(localStorage.getItem(key)) : null;
};

const putInWebStorage = (prefix, session)=> {
  const stringifiedSession = JSON.stringify(session);
  const uuid = uuidv4();
  localStorage.setItem(`${prefix}.${uuid}`, stringifiedSession);
};

const WebStorage = {
  clear: clearWebStorage,
  find: getFromWebStorage,
  put: putInWebStorage
};

export default WebStorage;